import React from "react";
import "./Form.css";

export default function EczaneForm() {
  return (
    <div className="row">
      <div className="col-12">
        <div className="formTitle">Eczaneler</div>
      </div>

      <div className="col-3" style={{ marginLeft: "10px" }}>
        İlçe2
      </div>

      <div className="col-8">
        <select className="form-control form-control-sm ">
          <option>Seçiniz</option>
        </select>
      </div>

      <div className="col-12">
        <center>
          <br />
          <b>Nöbetçi Eczaneler</b>
          <hr
            style={{ marginTop: "2px", marginBottom: "0px", color: "gray" }}
          />
        </center>
      </div>

      <div className="col-12" style={{ borderLeft: "1px solid gray" }}>
        <table className="table table-sm table-striped">
          <tr style={{ borderLeft: "1px solid gray", marginTop: "0px" }}>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Deva Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
          <tr style={{ borderLeft: "1px solid gray", marginTop: "0px" }}>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Doğuş Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
          <tr style={{ borderLeft: "1px solid gray", marginTop: "0px" }}>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Güven Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div className="col-12">
        <center>
          <b>Tüm Eczaneler</b>
          <hr
            style={{ marginTop: "2px", marginBottom: "0px", color: "gray" }}
          />
        </center>
      </div>

      <div className="col-12" style={{ borderLeft: "1px solid gray" }}>
        <table className="table table-sm table-striped">
          <tr>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Deva Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Doğuş Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <center>
                <button className="btn bg-light btn-sm btn-block">
                  <i className="fas fa-search-location fa-2x"></i>
                </button>
              </center>
            </td>
            <td style={{ width: "80%" }}>
              Güven Eczanesi
              <br />
              <div style={{ fontSize: "11px" }}>
                Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}
